import { unwrap } from 'api/schema/utils';
export default function parseOrderModelVariants(data) {
    const sizes = unwrap(data === null || data === void 0 ? void 0 : data.sizes) || [];
    const activeColors = unwrap(data === null || data === void 0 ? void 0 : data.colors) || [];
    const specificationVariants = unwrap(data === null || data === void 0 ? void 0 : data.variants) || [];
    const variants = activeColors.map(color => ({
        name: color.name, colorId: color.id, quantities: sizes.map(size => specificationVariants.find((variant) => { var _a, _b; return ((_a = variant === null || variant === void 0 ? void 0 : variant.orderModelColor) === null || _a === void 0 ? void 0 : _a.id) === color.id && ((_b = variant === null || variant === void 0 ? void 0 : variant.orderModelSize) === null || _b === void 0 ? void 0 : _b.id) === size.id; }))
    }));
    return {
        variants,
        activeColors,
        sizes,
    };
}
